import { Field, FieldProps } from 'formik'
import { ReactNode } from 'react'
import Indication from 'components/Indication'
import { RadioGroupWrapper } from './styles'
import { Radio, RadioChangeEvent } from 'antd'

interface IProps {
  children: ReactNode,
  name: string,
  indication?: string,
  hideError?: boolean,
  asColumn?: boolean,
  onChange?: (value: any) => void,
  noBottomMargin?: boolean
}

const RadioGroup = (props: IProps) => {
  const { name, indication, hideError, asColumn, noBottomMargin, onChange,
    children } = props

  return (
    <Field name={name}>
      {(props: FieldProps) =>
        <RadioGroupWrapper
          asColumn={asColumn}
          noBottomMargin={noBottomMargin}
        >
          <Radio.Group
            name={name}
            value={props.field.value}
            onChange={onChangeRadio(props, name, onChange)}
          >
            {children}
          </Radio.Group>

          {(indication || (props.form.errors[name] && !hideError)) &&
            <Indication hasError={!!props.form.errors[name]}>
              {props.form.errors[name] ? props.form.errors[name] : indication}
            </Indication>
          }
        </RadioGroupWrapper>
      }
    </Field>
  )
}

const onChangeRadio = (props: FieldProps, name: string, onChange?: (value: any) => void) =>
  (event: RadioChangeEvent) => {
    props.form.setFieldValue(name, event.target.value)

    onChange && onChange(event.target.value)
  }

export default RadioGroup
